"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
require("./SuccessMessage.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Paragraph = _typography.default.Paragraph;
var SuccessMessage = function SuccessMessage(props) {
  var _props$msg = props.msg,
    msg = _props$msg === void 0 ? 'A new account has been created for' : _props$msg,
    firstName = props.firstName,
    lastName = props.lastName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(Paragraph, null, msg), /*#__PURE__*/_react.default.createElement(Paragraph, {
    strong: true
  }, firstName, " ", lastName));
};
var _default = SuccessMessage;
exports.default = _default;